<template>
  <el-container>
    <el-header>

      <div class="toplogo">
        <img alt="" src="static/logo.jpg"> 
      </div>
      <div class="navimenu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1"><router-link :to="{path: '/'}" style="text-decoration: none;">实验中心</router-link></el-menu-item>
          <el-menu-item index="2">孵化申请</el-menu-item>
        </el-menu>
      </div>
      <div class="topmenu">
        <span @click="loginWarn" style="cursor: pointer;"><i class="el-icon-s-custom" style="margin-right: 5px"></i>登录</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="regWarn" style="cursor: pointer;"><i class="el-icon-s-check" style="margin-right: 5px"></i>注册</span>
      </div>
      <div class="topimg"><img alt="" src="static/fuhuajidi.jpg"></div>


    </el-header>
    <el-main style="padding-top: 0; text-align: center;">
      <el-carousel height="400px">
        <el-carousel-item>
          <h3 class="small"><img alt="" src="static/banner1.jpg" width="100%" height="400px"></h3>
        </el-carousel-item>
        <!-- <el-carousel-item>
          <h3 class="small"><img alt="" src="static/banner2.jpg" width="100%" height="400px"></h3>
        </el-carousel-item> -->
      </el-carousel>
      <div class="cardrow">
        <el-card shadow="always">
          <div slot="header" class="clearfix" style="line-height: 1px;" >
            <span style="float: right; padding-right: 20px; color: #409EFF"> <i class="el-icon-s-order"></i> 孵化申请</span>
          </div>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="课程名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="团队背景">
              <el-input v-model="form.team"></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input v-model="form.contact"></el-input>
            </el-form-item>
            <el-form-item label="课程介绍">
              <el-input type="textarea" v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item label="孵化周期">
              <el-col :span="11">
                <el-date-picker type="date" placeholder="开始日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker type="date" placeholder="结束日期" v-model="form.date2" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="资金情况">
              <el-checkbox-group v-model="form.type">
                <el-checkbox label="专项拨款" name="type"></el-checkbox>
                <el-checkbox label="地方拨款" name="type"></el-checkbox>
                <el-checkbox label="学校拨款" name="type"></el-checkbox>
                <el-checkbox label="院系预算" name="type"></el-checkbox>
                <el-checkbox label="校企合作" name="type"></el-checkbox>
                <el-checkbox label="院系自筹" name="type"></el-checkbox>
                <el-checkbox label="教师自筹" name="type"></el-checkbox>
                <el-checkbox label="三方捐赠" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="合作资源">
              <el-input v-model="form.partner"></el-input>
            </el-form-item>
            <el-form-item label="特殊优势">
              <el-input type="textarea" v-model="form.advantage"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即申请</el-button>
              <el-button @click="goReset">重置申请</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </el-main>

    <el-footer>Copyright 2020-2021 湖南交通工程学院  版权所有  All rights reserved <img src="https://xyt.xinchacha.com/img/icon/icon8.png" style="height:30px; width:98px; position:relative; top:10px;"></el-footer>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>申请已提交。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: '2',
      currentDate: new Date(),
      form: {
          name: '',
          team: '',
          contact: '',
          date1: '',
          date2: '',
          partner: '',
          type: [],
          advantage: '',
          desc: ''
        },
        dialogVisible: false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    onSubmit() {
      console.log(this.form);
      this.dialogVisible = true;
    },
    goReset() {
      this.form.name = '';
      this.form.team = '';
      this.form.contact = '';
      this.form.date1 = '';
      this.form.date2 = '';
      this.form.partner = '';
      this.form.type =  [];
      this.form.advantage = '';
      this.form.desc = '';
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    loginWarn() {
      this.$notify({
          title: '提示',
          message: '请直接从实验中心的课程目录下的对应虚拟仿真实验课程进入。',
          type: 'success',
          duration: 4000
        });
    },
    regWarn() {
      this.$notify({
          title: '警告',
          message: '未对外开放注册，本校教师和学生请联系实验中心建立账号。',
          type: 'warning',
          duration: 4000
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    height: 80px !important;
  }

  .el-footer {
    background-color: #a5bbd8;
    color: #fff;
    text-align: center;
    height: 60px;
    line-height: 60px;
    width: 100%;
    /* position: fixed;
    bottom: 0; */
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .toplogo {
    float: left;
    width: 350px;
    margin-left: 10%;
    line-height: 80px;
    /* background-color: #958ac2; */
    font-size: 16px;
    color:rgb(83, 126, 175)6
  }

  .topimg {
    float: right;
    width: 205px;
    
    line-height: 80px;
    /* background-color: #9cd68f; */
    margin-bottom: 0;
  }

  .topimg img {
    /* position: relative; */
    /* top: 50%; */
    /* padding-top: 15px; */
    margin-top: 15px;
    border-radius: 6px;
  }

  .topmenu {
    float: right;
    width: 200px;
    margin-right: 10%;
    line-height: 80px;
    /* background-color: #726c8d; */
    font-size: 14px;
    color:#4976e8;
    /* padding-left: 20px; */
  }

  .navimenu {
    float: left;
    line-height: 80px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 400px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .cardrow {
    width: 60%;
    margin: 0 auto;
    /* line-height: 80px; */
    margin-bottom:  20px;
  }

  .image {
    width: 100%;
    display: block;
    border-radius: 6px;
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 5px;
    line-height: 30px;
  }

  .button {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/ApplyRequest.vue